Greenmile.LoadAllSessionInfo = {

    startInitialFunctions: function () {
        Monet.I18n.checkResources();
        Greenmile.LoadAllSessionInfo.getGlobalConfiguration();
        Greenmile.LoadAllSessionInfo.initTimeout();

        window.removeMenu = function () {
            return function () {
                var menu = document.querySelector('.MonetUIFloatMenu');
                var parent;
                if (menu) {
                    var cn,
                        max = menu.childNodes.length,
                        canDelete = true;

                    for (cn = 0; cn < max; cn++) {
                        if (menu.childNodes[cn].className && menu.childNodes[cn].className === 'floatMenuContent') {
                            canDelete = false;
                        }
                    }

                    if (canDelete) {
                        parent = menu.parentNode;
                        parent.removeChild(menu);
                    }
                }
            };
        }();
    },

    initTimeout: function (minutes) {
        const timeToDecrease = minutes >= 3 ? 120000 : 60000;
        const miliseconds = minutes * 60000;
        const timeToOpenLogoffModal = miliseconds - timeToDecrease; 
        
        Monet.Session.User.timeToOpenLogoutModal = timeToOpenLogoffModal;
        Monet.Session.User.timeToLogoutAfterOpenModal = timeToDecrease;

        if(window.greenmileLogoffTimeoutId) {
            clearTimeout(window.greenmileLogoffTimeoutId);
            window.greenmileLogoffTimeoutId = null;
        };

        if(!!timeToOpenLogoffModal) {
            window.greenmileLogoffTimeoutId = setTimeout(
                Greenmile.LoadAllSessionInfo.openLogoffNoticeModal, 
                timeToOpenLogoffModal
            );
        };

        Greenmile.LoadAllSessionInfo.createLogoutTimeoutListeners();
    },

    createLogoutTimeoutListeners: function () {
        window.addEventListener('mousemove', this.clearModalTimeout, true);
        window.addEventListener('click', this.clearModalTimeout, true);
        window.addEventListener('scroll', this.clearModalTimeout, true);
        window.addEventListener('keydown', this.clearModalTimeout, true);
        window.addEventListener('touchstart', this.clearModalTimeout, true);
        window.addEventListener('touchend', this.clearModalTimeout, true);
        window.addEventListener('touchcancel', this.clearModalTimeout, true);
        window.addEventListener('touchleave', this.clearModalTimeout, true);
        window.addEventListener('touchmove', this.clearModalTimeout, true);
    },

    removeLogoutTimeoutListeners: function() {
        window.removeEventListener('mousemove', Greenmile.LoadAllSessionInfo.clearModalTimeout, true);
        window.removeEventListener('click', Greenmile.LoadAllSessionInfo.clearModalTimeout, true);
        window.removeEventListener('scroll', Greenmile.LoadAllSessionInfo.clearModalTimeout, true);
        window.removeEventListener('keydown', Greenmile.LoadAllSessionInfo.clearModalTimeout, true);
        window.removeEventListener('touchstart', Greenmile.LoadAllSessionInfo.clearModalTimeout, true);
        window.removeEventListener('touchend', Greenmile.LoadAllSessionInfo.clearModalTimeout, true);
        window.removeEventListener('touchcancel', Greenmile.LoadAllSessionInfo.clearModalTimeout, true);
        window.removeEventListener('touchleave', Greenmile.LoadAllSessionInfo.clearModalTimeout, true);
        window.removeEventListener('touchmove', Greenmile.LoadAllSessionInfo.clearModalTimeout, true);
    },

    openLogoffNoticeModal: function () {
        window.GreenmileReduxStore.dispatch({
            type: 'GREENMILE_OPEN_LOGOFF_MODAL'
        });
    },

    clearModalTimeout: function () {
        if (window.greenmileLogoffTimeoutId) {
            clearTimeout(window.greenmileLogoffTimeoutId);

            window.greenmileLogoffTimeoutId = setTimeout(
                Greenmile.LoadAllSessionInfo.openLogoffNoticeModal, 
                Monet.Session.User.timeToOpenLogoutModal
            );
        }
    },

    getGlobalConfiguration: function () {
        Monet.Session.Configurations = Monet.Session.ApplicationLoad.globalConfiguration;
        if(!Monet.Session.Configurations.authConfigId) {
            Monet.Session.Configurations.authConfigId = window.location.origin;
        }

        var gmStorage = new Greenmile.Storage.StoreMapPosition();

        if (!gmStorage.isUpdate()) {

            var userPreference = new Greenmile.UserPreferences.Requests();
            var userPreferenceActions = new Greenmile.UserPreferences.Actions();

            if (userPreferenceActions.getListPreferenceToSaveOrUpdate().length) {

                userPreferenceActions.saveOrUpdateUserPreferences();
                Greenmile.LoadAllSessionInfo.getAllPermissions();

            } else {

                var callback = function (userPreferenceActions) {

                    return function (data) {
                        userPreferenceActions.setPreferencesAfterLogin(data);
                        Greenmile.LoadAllSessionInfo.getAllPermissions();
                    };

                }(userPreferenceActions);

                userPreference.getInitUserPreferences(callback);

            }

        } else {
            Greenmile.LoadAllSessionInfo.getAllPermissions();
        }

        window.greenmiletimeoutId = setTimeout(App.checkUpdates, 30000);

        window.nodeServer = Monet.Session.Configurations.chatHost + '/dnode';

    },

    getAllPermissions: function () {
        Monet.Session = Monet.Session || {};
        Monet.Session.Security = Monet.Session.Security || {};
        Monet.Session.Security.permissions = Monet.Session.ApplicationLoad.permissions;

        Greenmile.LoadAllSessionInfo.getMapConfiguration();
    },
                            
    getMapConfiguration: function () {
        const data = Monet.Session.ApplicationLoad.mapConfiguration;
        const mapConfiguration = new App.Collections.MapConfigurations();

        Monet.Session.Configurations = Monet.Session.Configurations || {};

        if (data) {
            if (Object.keys(data).includes('map-configs')) {
              data['map-configs'] = data['map-configs'].reduce((obj, item) => {
                const name = Object.keys(item)[0];
                obj[name] = item[name];
                return obj;
              }, {})  
            }
            data.mapProviders = {
              ...data.mapProviders.reduce((obj, item) => ({
                  ...obj,
                  [item.name]: item
              }), {})
            };
            mapConfiguration.add(data);
            Monet.Session.Configurations.MapConfiguration = mapConfiguration;

            const google = data.mapProviders.google;
            let googleUrl = "https://maps.googleapis.com/maps/api/js";

            if(google && google.configs.clientId) {
                googleUrl += `?&client=${google.configs.clientId}`;
            }

            const googleScript = document.createElement('script');
            googleScript.setAttribute('src',googleUrl);
            googleScript.setAttribute('id',"googleMapsApi");
            googleScript.setAttribute('type',"text/javascript");
            document.head.appendChild(googleScript);
        } else {
            Monet.Session.isLogged = false;

            $.toast({
                message: "MapConfiguration is not configured",
                displayTime: 3000,
                inTime: 100,
                outTime: 400,
                vPosition: "center",
                hPosition: "center"
            });
        }

        Greenmile.LoadAllSessionInfo.getAutoArriveConfiguration();
    },

    getAutoArriveConfiguration: function () {

        var data = Monet.Session.ApplicationLoad.autoArriveConfigurations;

        if (data) {
            Monet.Session.Configurations = Monet.Session.Configurations || {};

            Monet.Session.Configurations.AutoArriveConfiguration = data[0];
        }

        Greenmile.LoadAllSessionInfo.loadGlobalConfigurations();

    },

    loadGlobalConfigurations: function () {

        var configurations = Monet.Session.Configurations;

        var callback = function () {
            App.init();
        };

        if (!configurations) {
            var data = Monet.Session.ApplicationLoad.globalConfiguration;
            callback();
            Monet.Authentication.setAppconfigurations(data);
        } else {
            callback();
        }

    },
    renderUserSelectOrganizations: function () {
        var data = {};
        if (Monet.Session.ApplicationLoad) {
            data = Monet.Session.ApplicationLoad.organizationsHierarchy;
        }
        new Greenmile.DispatcherSelectOrganizationContainer('#GreenmileDispatcherSelectOrganizations').setListOrganizations(data).render();
    }
};
